import React, { Component } from "react";
import MusicNoteIcon from "@material-ui/icons/MusicNote";
import Paper from "@material-ui/core/Paper";
import { Translation } from "react-i18next";
import { connect } from "react-redux";
import withStyles from "@material-ui/core/styles/withStyles";
import { styles } from "./ContentView.css";
import { _PermittedContent } from "../../_module/utils/PermittedContent";
import DownloadLink from "./../../util/downloader/DownloadLink";
import { Grid, Divider, Box, AppBar, Tabs, Tab, Chip } from "@material-ui/core";
// import trackfields from "../../_module/definition/trackFields";
import clsx from "clsx";
// import { _mlPlaylists, _mlPlaylistsMetadataConfig } from "../../_module/definition/MlPlaylists";
import { _PermittedSetting } from "../../_module/utils/PermittedSetting";
import HelpWrap from "../../modules/ml-admin/help-admin/help-view/HelpWrap";
import { helpModules } from "../../modules/ml-admin/help-admin/help-view/Const";
import CtagRulePreview from "../../util/c-tag-util/CtagRulePreview";
import {
  showCtagRulePreview,
  emptyCtagRulePreview,
} from "../../redux/actions/MlTrackLibraryActions";
// import trackField from "../../_module/definition/trackFields";
import { Link } from "react-router-dom";
import moment from "moment";
import Moment from "react-moment";
import Columns from "./Columns";
import { ColumnTypes } from "../../util/table-view/TableTypes";
import { AuthSrc } from "./../AuthSrc";
import { getContributorDetails } from "util/CommonFunc";
import CliIcon from "images/sky-music.png";
import { getUserDisplay } from "util/CommonFunc";
import { DurationDisplayText } from "util/DurationDisplay";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tabpanel-${index}`}
      {...other}>
      {value === index && <Box p={3}>{children}</Box>}
    </div>
  );
}

class ContentView extends Component {
  constructor() {
    super();
    this.state = {
      tabValue: 0,
      dirty: false,
      visibleData: true.valueOf,
      artWorkEdit: false,
      messageOpen: false,
      artworkMessageOpen: false,
      externalMessageOpen: false,
      artwork: null,
      prevId: null,
      currentItemId: null,
      selectedItem: null,
    };
  }

  colsDef = null;
  colsDefAll = null;

  generateColsDef(origin) {
    const {
      orgRuntime: {
        runtime: {
          _settingMetadataConditional,
          _settingMetadataFieldsDefault,
          _settingMetadataFieldsCommercial,
          _settingMetadataFieldsLibrary,
          _settingMetadataFieldsCommissioned,
          _mlMetadata,
          _trackMetadataConfig,
        },
      },
    } = this.props;
    this.colsDefAll = [];
    this.colsDef = [];

    const metaDataSetting = _PermittedContent(
      [_mlMetadata, _trackMetadataConfig],
      []
    ) || { setting: [] };
    this.colsDefAll = this.colsDef =
      _PermittedSetting(
        metaDataSetting.setting,
        _settingMetadataFieldsDefault
      ) || [];

    if (
      _PermittedSetting(metaDataSetting.setting, _settingMetadataConditional) ||
      false
    ) {
      if (origin.startsWith("library")) {
        this.colsDef =
          _PermittedSetting(
            metaDataSetting.setting,
            _settingMetadataFieldsLibrary
          ) || this.colsDefAll;
      } else if (origin.startsWith("commercial")) {
        this.colsDef =
          _PermittedSetting(
            metaDataSetting.setting,
            _settingMetadataFieldsCommercial
          ) || this.colsDefAll;
      } else if (origin.startsWith("commissioned")) {
        this.colsDef =
          _PermittedSetting(
            metaDataSetting.setting,
            _settingMetadataFieldsCommissioned
          ) || this.colsDefAll;
      }
    }
  }

  a11yProps = (index) => {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  };

  componentDidMount() {
    this.setDataSource();
  }

  componentDidUpdate() {
    const {
      musicData: { showCtagRule },
      showCtagRulePreview,
      emptyCtagRulePreview,
      data: { selectedItem: contentSelectedItem },
    } = this.props;

    if (showCtagRule) {
      this.setState({ tabValue: 3, doUpdate: false });
      showCtagRulePreview(false);
    }

    if (this.state.currentItemId !== contentSelectedItem.id) {
      emptyCtagRulePreview();
      this.setDataSource();
      this.setState({ currentItemId: contentSelectedItem.id });
    }

    // else if (uploadSelectedItem) {
    //     if ((this.state.currentItemId != uploadSelectedItem.id)) {
    //         emptyCtagRulePreview();
    //         this.setDataSource();
    //         this.setState({ currentItemId: uploadSelectedItem.id })
    //     }
    // }
  }

  setDataSource = () => {
    const {
      data: { selectedItem: contentSelectedItem },
    } = this.props;
    if (Object.keys(contentSelectedItem).length !== 0) {
      this.setState({ selectedItem: contentSelectedItem });
    }
    // else if (uploadSelectedItem) {
    //     this.setState({ selectedItem: uploadSelectedItem })

    // }
  };

  handleTabChange = (event, newValue) => {
    this.setState({ tabValue: newValue });
  };

  renderMetadata = (id, i, classes, selectedItem, t, prop) => {
    const {
      orgRuntime: {
        runtime: { _trackFields: trackField },
      },
    } = this.props;
    let column = Columns[id];

    let value =
      id === trackField.contributorsExtended.id &&
      selectedItem.contributorsExtended
        ? JSON.stringify(selectedItem.contributorsExtended)
        : selectedItem[id] && Array.isArray(selectedItem[id])
        ? selectedItem[id].join(", ")
        : selectedItem[id];

    return prop.tag ? (
      <div key={i} className={classes.trackTags}>
        <label
          className={
            id === "title" ? classes.trackTabsLabelBold : classes.trackTabsLabel
          }
          title={t(`track.${id}`)}>
          {t(`track.${id}`)}
        </label>
        {selectedItem[id] && Array.isArray(selectedItem[id])
          ? selectedItem[id].map((desc, i) => {
              return desc ? <Chip key={i} label={desc} /> : null;
            })
          : selectedItem[id]
          ? selectedItem[id]
          : ""}
      </div>
    ) : (
      <div key={i} className={classes.muDetailWrap}>
        <div
          className={clsx(
            id === "title" ? classes.muLabelsBold : classes.muLabels,
            classes.muLabels
          )}
          title={t(`track.${id}`)}>
          {t(`track.${id}`)}
        </div>
        <div className={classes.muSeperator}> :</div>
        {id === trackField.prodName.id ? (
          <div
            className={clsx(
              id === trackField.prodName.id
                ? classes.muDetailsBold
                : classes.muDetails,
              classes.muDetails
            )}
            title={value || ""}>
            {((selectedItem?.is_mcf_track == true || selectedItem?.mlCreated == true) ? <strong class="tablesLink">{value || ""}</strong> :
              <Link
                style={{ textDecoration: "none", color: "#fff" }}
                key={selectedItem.id}
                to={`/search/album/${selectedItem.prodId}`}>
                <strong class="tablesLink">{value || ""}</strong>
              </Link>
            )}
          </div>
        ) : id === trackField.duration.id ? (
          <div
            className={clsx(
              id === "title" ? classes.muDetailsBold : classes.muDetails,
              classes.muDetails
            )}
            title={DurationDisplayText({ seconds: value }) || ""}>
            {DurationDisplayText({ seconds: value }) || ""}
          </div>
        ) : id === trackField.contributorsExtended.id ? (
          <div
            className={clsx(
              id === "title" ? classes.muDetailsBold : classes.muDetails,
              classes.muDetails
            )}>
            {selectedItem.contributorsExtended
              ? getContributorDetails(selectedItem.contributorsExtended)
              : ""}
          </div>
        ) : trackField[id] && trackField[id].linkable ? (
          <div
            className={clsx(
              id === "title" ? classes.muDetailsBold : classes.muDetails,
              classes.muDetails
            )}>
            {value &&
              value.split(",").map((data, i, array) => (
                <Link
                  style={{ textDecoration: "none", color: "#fff" }}
                  key={`${i}_${data}`}
                  aria-label={"Open link"}
                  title={data}
                  to={{
                    pathname: `/search/tracks/${encodeURI(
                      data.trim().replace("/", "")
                    )}/${id}`,
                    state: {
                      q: `${data.trim()}`,
                      autofocus: false,
                    },
                  }}>
                  <strong class="tablesLink">
                    {data}
                    {i === array.length - 1 ? null : ", "}
                  </strong>
                </Link>
              ))}
          </div>
        ) : (
          <div
            className={clsx(
              id === "title" ? classes.muDetailsBold : classes.muDetails,
              classes.muDetails
            )}
            title={
              column?.type === ColumnTypes.datetime ||
              column?.type === ColumnTypes.date
                ? null
                : id === trackField.musicOrigin.id
                ? t(`modules.originLables.${value}`)
                : value || ""
            }>
            {column?.type === ColumnTypes.datetime ? (
              value ? (
                <Moment
                  format="DD/MM/YYYY h:mm:ss A"
                  titleFormat="DD/MM/YYYY h:mm:ss A"
                  withTitle>
                  {value}
                </Moment>
              ) : null
            ) : column?.type === ColumnTypes.date ? (
              value ? (
                <Moment format="DD/MM/YYYY" titleFormat="DD/MM/YYYY" withTitle>
                  {value}
                </Moment>
              ) : null
            ) : column?.type === ColumnTypes.users ? (
              value ? (
                getUserDisplay(String(value))
              ) : null
            ) : id === trackField.musicOrigin.id ? (
              t(`modules.originLables.${value}`)
            ) : column?.type === ColumnTypes.boolean ? (
              value ? (
                "Yes"
              ) : (
                "No"
              )
            ) : (
              value || ""
            )}
          </div>
        )}
      </div>
    );
  };

  getIpsText = (ipsArray) => {
    try {
      if (Array.isArray(ipsArray)) {
        return ipsArray
          ?.filter((r) => r?.fullName)
          .map((r) => r?.fullName)
          ?.join(", ");
      } else {
        return null;
      }
    } catch {
      return null;
    }
  };

  render() {
    const {
      classes,
      orgRuntime: {
        runtime: { _trackFields: trackfields },
      },
    } = this.props;

    const { selectedItem } = this.state;

    if (selectedItem && selectedItem.id)
      this.generateColsDef(
        (selectedItem[trackfields.musicOrigin.id] || "").toLowerCase()
      );

    return (
      <Translation>
        {(t, { i18n }) => (
          <Paper className={classes.sideBar} role="contentinfo">
            {
              <>
                <Paper
                  className={clsx(classes.disFlex, classes.buttomOveridden)}>
                  <h2 className={classes.muTitle}>
                    {selectedItem &&
                      (selectedItem[trackfields.trackTitle.id] &&
                      Array.isArray(selectedItem[trackfields.trackTitle.id])
                        ? selectedItem[trackfields.trackTitle.id].join(", ")
                        : selectedItem[trackfields.trackTitle.id] ||
                          t("libraryPreview.na"))}
                    <span className={classes.muSubTitle}>
                      {(selectedItem &&
                        (selectedItem[trackfields.performer.id] &&
                        Array.isArray(selectedItem[trackfields.performer.id])
                          ? selectedItem[trackfields.performer.id].join(", ")
                          : selectedItem[trackfields.performer.id])) ||
                        t("libraryPreview.na")}
                    </span>
                  </h2>
                  <HelpWrap config={helpModules.TSPWH} />
                  <DownloadLink track={selectedItem} />
                </Paper>
                <Paper>
                  <Box p={1}>
                    <Grid
                      container
                      direction="column"
                      alignItems="center"
                      justify="center">
                      {selectedItem &&
                      selectedItem[trackfields.prodArtworkUrl.id] ? (
                        <img
                          style={{ height: 240, width: 240 }}
                          src={AuthSrc(
                            selectedItem[trackfields.prodArtworkUrl.id]
                          )}
                          alt={selectedItem[trackfields.trackTitle.id] || ""}
                        />
                      ) : (
                        <Grid
                          container
                          direction="column"
                          alignItems="center"
                          justify="center"
                          style={{ height: 240, width: 240 }}>
                          {/* <MusicNoteIcon style={{ fontSize: 60 }} /> */}
                          <img
                            className={"emptyArtwork"}
                            style={{ width: 120 }}
                            src={CliIcon}
                            alt="Sky Music"
                          />
                        </Grid>
                      )}
                    </Grid>
                  </Box>
                  <Divider />
                </Paper>

                <AppBar className={classes.trackTabsHeader} position="static">
                  <Tabs
                    value={this.state.tabValue}
                    onChange={this.handleTabChange}
                    scrollButtons="auto"
                    variant="scrollable">
                    <Tab label="Metadata" {...this.a11yProps(0)} />
                    <Tab label="Tags" {...this.a11yProps(1)} />
                    <Tab label="All" {...this.a11yProps(2)} />
                    <Tab label="C-Tag Rules" {...this.a11yProps(3)} />
                  </Tabs>
                </AppBar>
                <TabPanel
                  className={classes.trackTabs}
                  value={this.state.tabValue}
                  index={0}>
                  <Paper className={classes.paperwrap}>
                    <div className={classes.muListWrap}>
                      {this.colsDef?.map((id, i) => {
                        const prop = trackfields[id] || {};
                        return !prop.tag
                          ? this.renderMetadata(
                              id,
                              i,
                              classes,
                              selectedItem,
                              t,
                              prop
                            )
                          : null;
                      })}
                    </div>
                  </Paper>
                </TabPanel>
                <TabPanel
                  className={classes.trackTabs}
                  value={this.state.tabValue}
                  index={1}>
                  <Paper className={classes.paperwrap}>
                    <div className={classes.muListWrap}>
                      {this.colsDef?.map((id, i) => {
                        const prop = trackfields[id] || {};
                        return prop.tag
                          ? this.renderMetadata(
                              id,
                              i,
                              classes,
                              selectedItem,
                              t,
                              prop
                            )
                          : null;
                      })}
                    </div>
                  </Paper>
                </TabPanel>

                <TabPanel
                  className={classes.trackTabs}
                  value={this.state.tabValue}
                  index={2}>
                  <Paper className={classes.paperwrap}>
                    <div className={classes.muListWrap}>
                      {this.colsDefAll?.map((id, i) => {
                        const prop = trackfields[id] || {};
                        return this.renderMetadata(
                          id,
                          i,
                          classes,
                          selectedItem,
                          t,
                          prop
                        );
                      })}
                    </div>
                  </Paper>
                </TabPanel>
                <TabPanel
                  className={classes.trackTabs}
                  value={this.state.tabValue}
                  index={3}>
                  <CtagRulePreview />
                </TabPanel>
              </>
            }
          </Paper>
        )}
      </Translation>
    );
  }
}

const mapStateToProps = (state) => ({
  data: state.smContentTrackReducer,
  mldata: state.mllibraryadmin,
  musicData: state.mltracklibrary,
  updateData: state.mlTrackUpdateReducer,
  orgRuntime: state.orgRuntime,
});

export default connect(mapStateToProps, {
  showCtagRulePreview,
  emptyCtagRulePreview,
})(withStyles(styles)(ContentView));
